module.exports = __webpack_public_path__ + "static/img/user-info-credit.23b4ba3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user-info-credit.png
// module id = L3LK
// module chunks = 18